/**
 * Helper methods for ui interaction
 */

devex = devex || {};
devex.uiUtils = devex.uiUtils || {};

/**
 * Scroll back to top
 */
devex.uiUtils.scrollToTop = function (target) {
  var height = 0;
  if (target) {
    height = $(target).offset().top - 20;
  }
  $('html, body').animate(
    {
      scrollTop: height,
    },
    'slow'
  );
};

/**
 * Add class to element when it is inside viewport
 *
 * @param {jQuery} $elem - jQuery element
 * @returns {boolean} - returns true if the element is inside the viewport
 */
devex.uiUtils.isScrolledIntoView = function ($elem) {
  var docViewTop = $(window).scrollTop();
  var docViewBottom = docViewTop + $(window).height();

  var elemTop = $($elem).offset().top;
  var elemBottom = elemTop + $($elem).height();

  return elemBottom <= docViewBottom && elemTop >= docViewTop;
};
